import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Loader2 } from 'lucide-react';

// Mapeamento de rotas -> módulo
const ROUTE_MODULE = {
  '/': 'dashboard',
  '/consolidado': 'consolidado',
  '/dre': 'dre',
  '/fluxo-caixa': 'fluxo-caixa',
  '/lancamentos': 'lancamentos',
  '/importar-fluxo-caixa': 'importar',
  '/cursos': 'cursos',
  '/contratos': 'contratos',
  '/contas-pagar': 'contas-pagar',
  '/cobranca': 'cobranca',
  '/meta-realizado': 'metas',
  '/fechamento': 'fechamento',
  '/empresas': 'cadastros',
  '/fontes-receita': 'cadastros',
  '/centros-custo': 'cadastros',
  '/categorias': 'cadastros',
  '/usuarios': 'usuarios',
};

export function moduleOfRoute(path) {
  return ROUTE_MODULE[path] || 'dashboard';
}

export default function ProtectedRoute({ children, requireMaster = false }) {
  const { user, loading, isMaster, canAccessModule } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-zinc-950">
        <Loader2 className="animate-spin text-amber-400" size={28} />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (requireMaster && !isMaster) {
    return <Navigate to="/" replace />;
  }

  const mod = moduleOfRoute(location.pathname);
  if (!canAccessModule(mod)) {
    // Redirecionar para primeiro módulo permitido
    const allowed = user.allowed_modules || [];
    if (allowed.length > 0) {
      const dest = {
        cobranca: '/cobranca',
        dashboard: '/',
        consolidado: '/consolidado',
        dre: '/dre',
        'fluxo-caixa': '/fluxo-caixa',
        cursos: '/cursos',
        contratos: '/contratos',
        'contas-pagar': '/contas-pagar',
        lancamentos: '/lancamentos',
        importar: '/importar-fluxo-caixa',
        metas: '/meta-realizado',
        fechamento: '/fechamento',
        cadastros: '/empresas',
      }[allowed[0]] || '/login';
      return <Navigate to={dest} replace />;
    }
    return <Navigate to="/login" replace />;
  }

  return children;
}
